import { StoreState } from "../index";

export const getCartValidationError = (state: StoreState) => state.cartValidationError.code;
export const getHadPhoneNumberError = (state: StoreState) => state.cartValidationError.hadPhoneNumberError;
export const getHadEmailError = (state: StoreState) => state.cartValidationError.hadEmailError;
export const getPhoneNumberValidationTracked = (state: StoreState) =>
  state.cartValidationError.phoneNumberValidationTracked;
export const getEmailValidationTracked = (state: StoreState) => state.cartValidationError.emailValidationTracked;
export const getAnyValidationErrorTracked = (state: StoreState) => state.cartValidationError.anyValidationErrorTracked;
export const getHadPassengerNameError = (state: StoreState) => state.cartValidationError.hadPassengerNameError;
